import { useListFetcherClassicHandler } from "./list-fetcher.hook";

const ListFetcherClassic = () => {
  useListFetcherClassicHandler();

  return null;
};

export default ListFetcherClassic;
